"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_2 = require("react");
var table_context_1 = require("../table/table-context");
var ArrowIndicatorUpOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorUpOutline"));
var ArrowIndicatorDownOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorDownOutline"));
exports.Header = styled_components_1.default.thead(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  svg {\n    height: 20px;\n  }\n"], ["\n  color: ", ";\n  svg {\n    height: 20px;\n  }\n"])), function (props) { return props.theme.colours.table.headerColor; });
exports.Header.displayName = 'Header';
var InternalRow = react_2.memo(styled_components_1.default.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  color: ", ";\n  background-color: ", ";\n  td {\n    padding: ", " 16px;\n  }\n\n  td:first-of-type {\n    border-left: ", " solid\n      ", ";\n\n    padding: ", " 40px;\n  }\n"], ["\n  position: relative;\n  color: ", ";\n  background-color: ",
    ";\n  td {\n    padding: ", " 16px;\n  }\n\n  td:first-of-type {\n    border-left: ", " solid\n      ", ";\n\n    padding: ", " 40px;\n  }\n"])), function (props) { return props.theme.colours.table.rowColor; }, function (props) {
    return (props.striped && props.theme.colours.table.rowBackgroundStriped) || props.alternateRowColor
        ? props.theme.colours.table.optionsBackground
        : props.theme.colours.table.rowBackground;
}, function (props) { return (props.condensed ? '9px' : '18px'); }, function (_a) {
    var indentation = _a.indentation;
    return indentation * 60 + "px";
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.table.borderColor;
}, function (props) { return (props.condensed ? '9px' : '18px'); }));
InternalRow.displayName = 'InternalRow';
var ToggleContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 40px;\n  height: 100%;\n  cursor: ", ";\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: ", ";\n\n  svg {\n    fill: ", ";\n    height: 30px;\n    width: 30px;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 40px;\n  height: 100%;\n  cursor: ", ";\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: ", ";\n\n  svg {\n    fill: ",
    ";\n    height: 30px;\n    width: 30px;\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'auto');
}, function (_a) {
    var commonRow = _a.theme.colours.commonRow, disabled = _a.disabled;
    return (disabled ? commonRow.disabled : 'white');
});
ToggleContainer.displayName = 'ToggleContainer';
exports.RowToggle = function (_a) {
    var isOpen = _a.isOpen, onToggle = _a.onToggle, testID = _a.testID, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (react_1.default.createElement(ToggleContainer, { onClick: disabled ? undefined : onToggle, "data-test-id": testID || 'row-toggle-button', disabled: disabled },
        isOpen && react_1.default.createElement(ArrowIndicatorUpOutline_1.default, null),
        !isOpen && react_1.default.createElement(ArrowIndicatorDownOutline_1.default, null)));
};
exports.RowToggle.displayName = 'RowToggle';
exports.Row = function (_a) {
    var _b = _a.indentation, indentation = _b === void 0 ? 0 : _b, className = _a.className, striped = _a.striped, children = _a.children, toggleable = _a.toggleable, noSpaceAfter = _a.noSpaceAfter;
    var rowProps = table_context_1.useTableContext();
    var noSpacing = rowProps.noSpacing;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InternalRow, __assign({}, rowProps, { className: className, indentation: indentation, striped: striped, toggleable: toggleable }), children),
        !noSpacing && !noSpaceAfter && react_1.default.createElement(exports.RowSpacing, null)));
};
exports.Row.displayName = 'Row';
exports.RowSpacing = styled_components_1.default.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 8px;\n"], ["\n  height: 8px;\n"])));
exports.RowSpacing.displayName = 'RowSpacing';
exports.NoRows = styled_components_1.default.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0;\n  font-style: italic;\n"], ["\n  margin: 0;\n  font-style: italic;\n"])));
exports.NoRows.displayName = 'NoRows';
exports.Table = styled_components_1.default.table(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  border-collapse: collapse;\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n"])));
exports.Table.displayName = 'Table';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
